"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embeddedCellProcessor = void 0;
const react_1 = __importDefault(require("react"));
const GridExpandableCell_1 = require("../../../renderers/gridExpandableCell/GridExpandableCell");
const embeddedCellProcessor = (columns, config) => {
    var _a;
    const columnsWithoutService = columns.filter((column) => !column.isService);
    const serviceColumnsCount = columns.filter((column) => column.isService).length;
    const sortedNestedColumn = (_a = columnsWithoutService.find((column) => column.order === serviceColumnsCount)) !== null && _a !== void 0 ? _a : columns[serviceColumnsCount];
    if (!sortedNestedColumn) {
        return [...columns];
    }
    const nestedColumnCell = sortedNestedColumn.cell;
    sortedNestedColumn.cell = (props) => {
        const rowIndex = props.rowIndex;
        const meta = config.getMetaByIndex(props.rowIndex);
        const newProps = Object.assign({}, props);
        newProps.column.hasPaddings = false;
        return (react_1.default.createElement(GridExpandableCell_1.GridExpandableCell, { isExpandable: meta.isExpandable, depth: meta.depth, isExpanded: meta.isExpanded, onClick: () => config.onClick(rowIndex, meta) }, meta.isExpandable
            ? config.cellRenderer(newProps, meta)
            : nestedColumnCell(newProps)));
    };
    return [...columns];
};
exports.embeddedCellProcessor = embeddedCellProcessor;
//# sourceMappingURL=embeddedCellProcessor.js.map